"use client";

/**
 * NewForm DS hover icon — two uprights for "hold this".
 * On hover they ease apart and settle, so the glyph acts out the gap it
 * puts in the recording rather than sitting still.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function PauseIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <rect
        className="a-pause-l"
        x="7.4"
        y="5"
        width="3.4"
        height="14"
        rx="1.7"
        fill="currentColor"
      />
      <rect
        className="a-pause-r"
        x="13.2"
        y="5"
        width="3.4"
        height="14"
        rx="1.7"
        fill="currentColor"
      />
    </HoverIconSvg>
  );
}
